module.exports = __webpack_public_path__ + "img/arrow-download-alt.660b2dbf.svg";